(() => {
  const parseCandidates = (card) => {
    const script = card.querySelector('[data-collection-cover-candidates]');
    if (!script) return [];

    try {
      const candidateText = script.content ? script.content.textContent : script.textContent;
      return JSON.parse(candidateText).filter((candidate) => candidate && candidate.id && candidate.src);
    } catch (_error) {
      return [];
    }
  };

  const candidateKey = (candidate) => candidate.src || candidate.id;

  const chooseCandidate = (candidates, usedKeys) => {
    const available = candidates.filter((candidate) => !usedKeys.has(candidateKey(candidate)));
    const pool = available.length > 0 ? available : candidates;

    if (pool.length === 0) return null;

    return pool[Math.floor(Math.random() * pool.length)];
  };

  const waitForImage = (image) => {
    if (!image || image.complete) return Promise.resolve();
    if (image.decode) return image.decode().catch(() => {});

    return new Promise((resolve) => {
      image.addEventListener('load', resolve, { once: true });
      image.addEventListener('error', resolve, { once: true });
    });
  };

  const applyCandidate = async (card, candidate) => {
    const image = card.querySelector('[data-collection-cover-image]');
    if (!image || !candidate) return;

    image.removeAttribute('srcset');
    image.src = candidate.src;
    image.alt = candidate.alt || image.alt;

    if (candidate.width) image.width = candidate.width;
    if (candidate.height) image.height = candidate.height;

    await waitForImage(image);
  };

  document.querySelectorAll('[data-collection-cover-rotation-list]').forEach((list) => {
    const usedKeys = new Set();
    const cards = Array.from(list.querySelectorAll('[data-collection-cover-card]')).map((card, index) => ({
      card,
      candidates: parseCandidates(card),
      index,
    }));
    const assignments = new Map();

    [...cards]
      .sort((firstCard, secondCard) => firstCard.candidates.length - secondCard.candidates.length)
      .forEach(({ card, candidates }) => {
        const candidate = chooseCandidate(candidates, usedKeys);

        if (!candidate) return;

        usedKeys.add(candidateKey(candidate));
        assignments.set(card, candidate);
      });

    cards.forEach(async ({ card }) => {
      await applyCandidate(card, assignments.get(card));
      card.classList.add('collection-cover-ready');
    });
  });
})();
